import ChargeBeePurchaseCompleteComponent from '@/views/ChargeBeePurchaseComplete.vue';
import RouteNames from '../constants/route-names';

const chargeBeePurchaseCompleteRoute = {
  component: ChargeBeePurchaseCompleteComponent,
  name: RouteNames.ChargeBeePurchaseComplete,
  path: '/chargebee/purchase-complete',
  props: route => ({
    redirectUrl: route.query.redirectUrl,
    hostedPageId: route.query.id,
    status: route.query.state,
  }),
};

export default chargeBeePurchaseCompleteRoute;
